export default "__VITE_ASSET__CtPtIYHO__"